var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-aside',{attrs:{"width":_vm.width}},[(_vm.$slots.aside)?_vm._t("aside"):_c('span',[_vm._v("Aside")])],2),_c('el-header',{attrs:{"height":"auto"}},[(_vm.$slots.header)?_vm._t("header"):_c('span',[_vm._v("Header")])],2),_c('el-main',[_c('div',{staticClass:"main"},[(_vm.$slots.main)?_vm._t("main"):_vm._e()],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e8913c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/comp/Layout/_.pug
// module id = null
// module chunks = 